import React, { useEffect } from 'react'
import useAuth from '../hooks/useAuth'

const Login: React.FC = () => {
  const { login, isLoading, isAuthenticated } = useAuth()

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (isAuthenticated) {
      window.location.replace('/')
      return
    }
    login()
  }, [login, isLoading, isAuthenticated])

  return (
    <div>
      <h1>Logging you in…</h1>
      <p>Please wait while we redirect you to the authentication page.</p>
    </div>
  )
}

export default Login
